import React from "react";
import { GRADE_TO_PRIORITY, getClassName } from "@sscs/utils";
import { CheckIcon, CloseIcon } from "../../icons";
import styles from "./priorityIcon.module.scss";
const Hexagon = ({ colorClassName, contentClassName, size, children, }) => (React.createElement("div", { className: getClassName(styles.hexagon, styles[`size-${size}`]) },
    React.createElement("svg", { className: getClassName(styles.shape, colorClassName), viewBox: "0 0 40 46", "aria-hidden": "true" },
        React.createElement("polygon", { points: "20,6 34,13 34,33 20,40 6,33 6,13", strokeLinejoin: "round" })),
    React.createElement("span", { className: getClassName(styles.content, { [styles.text]: typeof children === "string" }, contentClassName) }, children)));
const PriorityIcon = ({ grade, status, hasIssues, hasFailedChecks = false, size = "md", }) => {
    if (hasFailedChecks)
        return (React.createElement(Hexagon, { colorClassName: styles.fail, contentClassName: styles.glyph, size: size },
            React.createElement(CloseIcon, { size: "inherit" })));
    if (!hasIssues)
        return (React.createElement(Hexagon, { colorClassName: styles.pass, contentClassName: styles.glyph, size: size },
            React.createElement(CheckIcon, { size: "inherit" })));
    return (React.createElement(Hexagon, { size: size, colorClassName: getClassName({
            [styles.pass]: status === "pass",
            [styles.fail]: status === "fail",
            [styles["p0-pass"]]: status === "pass" && grade === "F",
        }), contentClassName: grade === "D" ? styles.p1 : undefined }, GRADE_TO_PRIORITY[grade]));
};
export default PriorityIcon;
//# sourceMappingURL=PriorityIcon.js.map